import React, { useEffect, useState } from "react";
const API_URL = process.env.REACT_APP_API_URL || "";

const UserInfo = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("access");

    fetch(`${API_URL}/api/me/`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => setUser(data))
      .catch(err => console.error("Errore caricamento utente:", err));
  }, []);

  if (!user) return <p>Caricamento dati...</p>;

  return (
    <div className="card p-3 shadow-sm my-4">
      <strong>Utente:</strong> {user.username} <br />
      <strong>Ruolo:</strong> {user.role} <br />
      <strong>Punto vendita:</strong> {user.store_name || "—"}
    </div>
  );
};

export default UserInfo;
